import {
	CreateEmailTemplateDto,
	EmailTemplate,
	UpdateEmailTemplateDto,
} from "@dune/types";
import { getErrorMessage } from "@dune/vars";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { privateAxios } from "../axios";

export const createEmailTemplate = async (
	createDto: CreateEmailTemplateDto,
): Promise<EmailTemplate> => {
	const { data } = await privateAxios.post<EmailTemplate>(
		"/email-templates",
		createDto,
	);
	return data;
};

export const useCreateEmailTemplate = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: createEmailTemplate,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["email-templates"] });
			toast.success("Modèle d'email créé avec succès");
		},
		onError: (error) => {
			const errorMessage = getErrorMessage(error);
			toast.error("Erreur lors de la création du modèle d'email", {
				description: errorMessage,
			});
		},
	});
};

export const updateEmailTemplate = async (
	id: string,
	updateDto: UpdateEmailTemplateDto,
): Promise<EmailTemplate> => {
	const { data } = await privateAxios.put<EmailTemplate>(
		`/email-templates/${id}`,
		updateDto,
	);
	return data;
};

export const useUpdateEmailTemplate = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: ({
			id,
			updateDto,
		}: { id: string; updateDto: UpdateEmailTemplateDto }) =>
			updateEmailTemplate(id, updateDto),
		onSuccess: (data) => {
			queryClient.invalidateQueries({ queryKey: ["email-templates"] });
			queryClient.setQueryData(["email-templates", data.id], data);
			toast.success("Modèle d'email mis à jour avec succès");
		},
		onError: (error) => {
			const errorMessage = getErrorMessage(error);
			toast.error("Erreur lors de la mise à jour du modèle d'email", {
				description: errorMessage,
			});
		},
	});
};

export const deleteEmailTemplate = async (id: string): Promise<void> => {
	await privateAxios.delete(`/email-templates/${id}`);
};

export const useDeleteEmailTemplate = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: deleteEmailTemplate,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["email-templates"] });
			toast.success("Modèle d'email supprimé avec succès");
		},
		onError: (error) => {
			const errorMessage = getErrorMessage(error);
			toast.error("Erreur lors de la suppression du modèle d'email", {
				description: errorMessage,
			});
		},
	});
};
